import { render, staticRenderFns } from "./HandleCard.vue?vue&type=template&id=d6d34570"
import script from "./HandleCard.vue?vue&type=script&lang=js"
export * from "./HandleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports